import React from "react";
import ProfileDropdown from "./ProfileDropdown";
import NotificationDropdown from "./NotificationDropdown";

type TopbarProps = {
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Topbar: React.FC<TopbarProps> = ({ sidebarOpen, setSidebarOpen }) => {
  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <header className="w-full bg-white dark:bg-gray-900 px-6 h-20 flex justify-between items-center border-b border-gray-200 dark:border-gray-800 sticky top-0 z-10">
      {/* Left side - Hamburger menu (only on mobile) */}
      <div className="flex items-center">
        <button
          className="text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700"
          onClick={handleSidebarToggle}
          aria-label="Toggle sidebar"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-panel-left"
          >
            <rect width="18" height="18" x="3" y="3" rx="2" />
            <path d="M9 3v18" />
          </svg>
        </button>
      </div>

      {/* Right side - notifications and user info */}
      <div className="flex items-center justify-end gap-4">
        <NotificationDropdown />
        <ProfileDropdown
          user={{
            name: sessionStorage.getItem("entra_name") || "User",
            email: sessionStorage.getItem("entra_email") || "user@example.com",
            role: sessionStorage.getItem("role") || "User"
          }}
        />
      </div>
    </header>
  );
};

export default Topbar;
